<template>
  <div>
    <table-con>
      <div slot="search">
        <div class="goodsCard">
          <div class="table-title">
            <p style="font-size: 15px">商品信息</p>
          </div>
          <div class="flex-row" style="margin-top: 10px">
            <el-image
              style="
                width: 100px;
                height: 100px;
                margin-right: 10px;
                cursor: pointer;
              "
              :src="goodsInfo.pictureUrl"
              @click="chackImg(goodsInfo)"
            ></el-image>
            <div class="flex-1 flex-column justify-around">
              <p>商品编码：{{ goodsInfo.goodsCode }}</p>
              <p>商品名称：{{ goodsInfo.goodsName }}</p>
              <p>商品链接：<a :href="goodsInfo.goodsUrl">商品链接</a></p>
            </div>
            <div class="flex-1 flex-column justify-around">
              <p>
                商品渠道：{{
                  returnStatus(goodsInfo.platformType, platformType_status)
                }}
              </p>
              <p>平均系数：{{ goodsInfo.checkCoefficientAvg }}</p>
              <p>采购次数：{{ goodsInfo.orderCount }}</p>
            </div>
            <div class="flex-1 flex-column justify-around">
              <p>录入日期： {{ goodsInfo.createTime | dateFormatToSecond }}</p>
              <p>录入用户：{{ goodsInfo.createUserName }}</p>
              <p>平均价格：{{ goodsInfo.priceAvg }}</p>
            </div>
          </div>
          <div class="flex-1 flex-column justify-around" style="margin-left: 110px;">
            <p style="margin-top: 2px;">中文产品描述： {{ goodsInfo.productDesc }}</p>
            <p style="margin-top: 5px;">英文产品描述：{{ goodsInfo.productDescEn }}</p>
          </div>
        </div>
      </div>
      <div slot="table" class="full-height display-col table">
        <!-- <div>
          <div class="table-title">
            <p style="font-size: 15px">基本信息</p>
          </div>
          <el-form
            ref="form"
            :model="query"
            label-width="6rem"
            label-suffix="："
          >
            <el-form-item label="商品分类">
              <el-cascader
                :options="options"
                :props="{ checkStrictly: true }"
                clearable
                size="small"
              ></el-cascader>
            </el-form-item>
          </el-form>
        </div> -->
        <div style="height: 100%">
          <div class="table-title">
            <p style="font-size: 15px">采购记录</p>
          </div>
          <el-table
            style="margin-top: 10px"
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
            :data="pageList.tableData"
            :height="tableResize.tableHeight"
            border
          >
            <el-table-column type="index" label="序号" align="center">
            </el-table-column>
            <el-table-column prop="createTime" label="采购日期" align="center">
              <template #default="{ row }">
                {{ row.createTime | dateFormatToSecond }}
              </template>
            </el-table-column>
            <el-table-column
              prop="customerUserName"
              label="客户"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="orderId" label="NO" align="center">
            </el-table-column>
            <el-table-column
              prop="buyAccountNumber"
              label="采购账号"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="buyOrderNumber"
              label="采购订单号"
              align="center"
            />
            <el-table-column prop="price" label="采购价格" align="center">
            </el-table-column>
            <el-table-column
              prop="checkCoefficient"
              label="检品系数"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="evaluate" label="采购评价" align="center">
              <template #default="{ row }">
                <el-input-number
                  :min="0"
                  size="mini"
                  :max="10"
                  @change="getEvalue(row)"
                  v-model="row.evaluate"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center">
              <template #default="{ row }">
                <el-input
                  type="textarea"
                  placeholder="请输入备注"
                  @blur="getEvalue(row)"
                  v-model="row.remark"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-bind="pagination"
            @size-change="pagination.sizeChange"
            @current-change="pagination.currentChange"
          ></el-pagination>
        </div>
        <!-- <div style="margin-top: 10px">
          <div class="table-title">
            <p style="font-size: 15px">标签</p>
          </div>
          <div style="margin-top: 10px">
            <el-tag
              :key="index"
              v-for="(tag, index) in dynamicTags"
              :type="tag.type"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
              style="margin-top: 10px"
            >
              {{ tag.label }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              >+ New Tag</el-button
            >
          </div>
        </div> -->
      </div>
    </table-con>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible" width="30%">
      <img :src="dialogPic" width="100%" height="100%" />
    </el-dialog>
  </div>
</template>

<script>
import { returnStatus, platformType_status } from "@/class/status";
import { TableResize } from "@/assets/js/utils";
import { PageList } from "@/class";
export default {
  data() {
    const pageList = new PageList();
    const { queryInfo, pagination, page } = pageList;
    return {
      returnStatus: returnStatus,
      platformType_status: platformType_status,
      tableResize: new TableResize(450),
      //列表、查询及分页
      pageList: pageList,
      queryInfo: queryInfo,
      query: queryInfo.query,
      page: page,
      pagination: pagination,
      visiable: false,
      dialogVisible: false,
      dialogPic: undefined,
      title: undefined,
      queryData: {},
      options: [],
      goodsInfo: {},

      dynamicTags: [
        { type: "", label: "标签一" },
        { type: "success", label: "标签二" },
        { type: "info", label: "标签三" },
        { type: "danger", label: "标签四" },
        { type: "warning", label: "标签五" },
      ],
      inputVisible: false,
      inputValue: "",
    };
  },
  mounted() {
    this.tableResize.onRun();
    // console.log('onRun', this.tableResize)
  },
  destroyed() {
    this.tableResize.onStop();
  },
  created() {
    // console.log(this.$route.query.id, "id");
    if (this.$route.query.id) {
      this.getOrderList();
      this.getGoodsList();
      this.queryInfo.searchList();
    }
  },
  methods: {
    // 查看图片
    chackImg(row) {
      this.dialogVisible = true;
      this.dialogPic = row.pictureUrl;
      console.log(this.dialogPic);
    },
    // 编辑评价adn备注
    getEvalue(row) {
      let data = {
        id: row?.id,
        evaluate: row?.evaluate,
        remark: row?.remark,
      };
      this.$http.post("/purchase/updateOrder", data).then((res) => {
        const { data: resData } = res;
        if (resData.code == 200) {
          this.$message({
            type: "success",
            message: resData.data,
          });
          this.queryInfo.searchList();
        }
      });
    },
    // 商品详情列表
    getGoodsList() {
      //重写请求列表接口
      let params = {
        // ...this.page,
        ...this.query,
        id: this.$route.query.id,
      };
      console.log(params, "params");
      // return;
      this.$http
        .get("/purchase/goodsDetail", {
          params: params,
        })
        .then((res) => {
          const { data: resData } = res;
          this.goodsInfo = resData.data;
        });
    },
    // 订单详情列表
    getOrderList() {
      //重写请求列表接口
      this.queryInfo.searchList = () => {
        let params = {
          ...this.page,
          ...this.query,
          purchaseGoodsId: this.$route.query.id,
        };
        console.log(params, "params");
        // return;
        this.$http
          .get("/purchase/orderList", {
            params: params,
          })
          .then((res) => {
            const { data: resData } = res;
            this.pageList.update(resData);
          });
      };
    },
    // 删除标签
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    // 显示标签
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 添加标签
    handleInputConfirm() {
      let inputValue = this.inputValue;
      let type = ["", "success", "info", "danger", "warning"];
      if (inputValue) {
        let foo = type[Math.floor(Math.random() * type.length)];
        this.dynamicTags.push({
          type: foo,
          label: inputValue,
        });
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style lang="less" scoped>
.table-title {
  padding: 5px 0;
  text-align: left;
  background: #f1f2f6;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px;
}
.table {
  height: calc(100vh - 340px);
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
